import { Field } from 'formik';
import { useIntl } from 'react-intl';
import { FieldProps } from '../../types/fields';
import getValidator from '../../utils/getValidator';
import TextField from '../formik/TextField';
import { config } from '../../utils/config';

type EmailFieldProps = FieldProps & {
  type: 'signIn' | 'register' | 'passwordReset' | 'guest';
  autocomplete?: 'username' | 'email';
};

const EmailField = (props: EmailFieldProps) => {
  const { formatMessage } = useIntl();
  const { context, testIdPrefix, autocomplete } = props;
  const { layeredValidation } = config.emailPassword.email;

  return (
    <Field
      name={[context, 'email'].filter(Boolean).join('.')}
      component={TextField}
      label={formatMessage({ id: 'generic.email' })}
      maxLength={60}
      validate={
        ['register', 'guest'].includes(props.type)
          ? getValidator({ required: true, minLength: 5, format: 'email', layeredValidation })
          : getValidator({ required: true, minLength: 5, format: 'email' })
      }
      data-test-id={`${testIdPrefix}-email`}
      type="email"
      autoComplete={autocomplete}
    />
  );
};

export default EmailField;
